module.exports = __webpack_public_path__ + "img/vertical_6_7_8023.5c7f425e.png";